'use client'

import React, { ReactElement, ReactNode } from 'react'
import classNames from 'classnames'

export function FilterButton(props: {
  children: ReactNode
  selected: boolean
  onClick: () => void
}): ReactElement {
  return (
    <button
      onClick={props.onClick}
      className={classNames('whitespace-nowrap rounded-md border-2 px-3 pb-1 pt-2.5 text-sm', {
        'border-black-64': props.selected,
      })}
    >
      {props.children}
    </button>
  )
}